import posthog from 'posthog-js';

import type { BrowserEventName, BrowserEvents } from './events';

export function captureBrowserEvent<T extends BrowserEventName>(
  event: T,
  properties: BrowserEvents[T]
) {
  if (typeof window === 'undefined') {
    return;
  }

  posthog.capture(event, properties);
}

export function stopBrowserAnalyticsForObjection() {
  if (typeof window === 'undefined') {
    return;
  }

  posthog.reset();
  posthog.clear_opt_in_out_capturing();
}
